// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"styles_MainContainer__2UHsm","Logo":"styles_Logo__kb83-"};